const intervalId = setInterval(() => {
  if (window.tlCartGoalEmbed) {
    clearInterval(intervalId);

    window.tlCartGoalEmbed.getRewardTitleByType = (milestone) => {
        let imgSrc, title, beforeAchieve, afterAchieve;
        switch (milestone.reward_type) {
            case "gift":
                imgSrc = window.tlCartGoalEmbed.giftSVG;
                title = window.tlCartGoalEmbed.translation.milestone.gift.title;
                beforeAchieve = window.tlCartGoalEmbed.replaceVariables(window.tlCartGoalEmbed.translation.milestone.gift.before_achieve, milestone, title);
                afterAchieve = window.tlCartGoalEmbed.replaceVariables(window.tlCartGoalEmbed.translation.milestone.gift.after_achieve, milestone, title);
                break;
            case "discount":
                imgSrc = window.tlCartGoalEmbed.discountSVG;
                title = window.tlCartGoalEmbed.translation.milestone.order_discount.title;
                beforeAchieve = window.tlCartGoalEmbed.replaceVariables(window.tlCartGoalEmbed.translation.milestone.order_discount.before_achieve, milestone, title);
                afterAchieve = window.tlCartGoalEmbed.replaceVariables(window.tlCartGoalEmbed.translation.milestone.order_discount.after_achieve, milestone, title);
                break;
            case "free_ship":
                imgSrc = window.tlCartGoalEmbed.freeShippingSVG;
                title = milestone.title;
                beforeAchieve = window.tlCartGoalEmbed.replaceVariables(window.tlCartGoalEmbed.translation.milestone.shipping_discount.before_achieve, milestone, title);
                // afterAchieve = window.tlCartGoalEmbed.replaceVariables(window.tlCartGoalEmbed.translation.milestone.shipping_discount.after_achieve, milestone, title);
                afterAchieve = milestone.reward_description_after;
                break;
        }

        return [title, beforeAchieve, afterAchieve, imgSrc]
    }
  }
}, 50);

setTimeout(() => {
  clearInterval(intervalId);
}, 3000);